import { ReportesAnotacionesService } from "./reportes-anotaciones.service";
import { NgbModal, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { AuthService } from "./../../../../../../../shared/services/auth.service";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  FormControl,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { CampoAdicionalCategoriaService } from "../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
import { DocumentoSubcategoriaService } from "../../configuracion/documento-subcategoria/documento-subcategoria.service";
import { AccionRntService } from "../../configuracion/accion-rnt/accion-rnt.service";
import { ModuloAyudaService } from "../../configuracion/modulo-ayuda/modulo-ayuda.service";
import { CompletaInformacionService } from "../../../prestador/pasos/completa-informacion/completa-informacion.service";
import { HttpEventType } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { TipoSolicitudEntry } from "src/app/shared/entrys/tipo-solicitud.entry";
import { EstadoSolicitudEntry } from "src/app/shared/entrys/estado-solicitud.entry";
import { AnotacionService } from "../../../prestador/anotacion/anotacion.service";
import { RntConsultaService } from "../../../funcionario/rnts-consulta/rnt-consulta.service";
import { ModalSeleccionFuncionarioComponent } from "src/app/components/core/layouts/modal-seleccion-funcionario/modal-seleccion-funcionario.component";

@Component({
  // tslint:disable-next-line:indent
  selector: "app-reportes-anotaciones",
  // tslint:disable-next-line:indent
  templateUrl: "./reportes-anotaciones.component.html",
  // tslint:disable-next-line:indent
  styleUrls: ["./reportes-anotaciones.component.scss"],
})
export class ReportesAnotacionesComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerTabla: Array<string>;
  formUsuario: FormGroup;
  selectUsuario: any;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminSuper = RolesUsuario.AdministradorSuper;
  prestador = RolesUsuario.Prestador;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  camaraComercio: string;
  // Selects
  categoria: Array<any> = [];
  subcategoria: Array<any> = [];
  estadoRnt: Array<any> = [];
  tipoRNT: Array<any> = [];
  departamento: Array<DepartamentoEntry> = [];
  municipio: Array<MunicipioEntry> = [];
  tipoSolicitudLista: Array<TipoSolicitudEntry> = [];
  estadoSolicitudLista: Array<EstadoSolicitudEntry> = [];
  tipos_anotacion: Array<any>;
  exportarForm: FormGroup;
  fecha_inicio: any;
  estadoRntValidator: boolean;
  exportarList = [
    { id: "DESC_CAMARA", name: "Cámara de Comercio" },
    { id: "CODIGO_RNT", name: "Número RNT" },
    { id: "DESCRIPCION_ESTADO_RNT", name: "Estado RNT" },
    { id: "DESCRIPCION_TIPO_RNT", name: "Tipo RNT" },
    { id: "RAZON_SOCIAL", name: "Nombre o Razón social" },
    { id: "NIT", name: "Nit" },
    { id: "DIGITO_VERIFICACION", name: "Dígito verificación" },
    { id: "MATRICULA", name: "Número Matrícula" },
    { id: "DESCRIPCION_TIPO_SOLICITUD", name: "Tipo solicitud" },
    { id: "DESCRIPCION_ESTADO_SOLICITUD", name: "Estado solicitud" },
    { id: "FECHA_RADICACION", name: "Fecha radicación" },
    { id: "NUMERO_RADICACION", name: "Número radicación" },
    { id: "FECHA_ULTIMA_ACTUALIZACION", name: "Fecha última actualización" },
    { id: "DESC_TIPO_ANOTACION", name: "Tipo anotación" },
    { id: "DESC_ANOTACION", name: "Anotación" },
    { id: "FECHA_CREACION", name: "Fecha creación" },
    { id: "DESC_TIPO_USUARIO,USUARIO_CREACION", name: "Usuario de creación" },
    { id: "CAUSAL_DEVOLUCION", name: "Causal de devolucion" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private reportesAnotacionesService: ReportesAnotacionesService,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private rntConsultaService: RntConsultaService,
    private tipoRntService: ModuloAyudaService,
    private anotacionService: AnotacionService,
    private modalService: NgbModal
  ) {
    this.createPagingTable();
    this.createForm();

    this.selectUsuario = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.titleTable();
    this.onCamaraSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
    this.onEstadoSolicitud();
    this.onTipoSolicitud();
    this.onAnotaciones();
    this.onChanges();
  }

  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      nit: [null],
      numero_radicacion: [null],
      codigo_rnt: [null],
      matricula: [null],
      estado_rnt_id: [null, Validators.compose([Validators.required])],
      estado_solicitud_id: [null],
      tipo_solicitud_id: [null],
      tipo_anotacion_id: [null],
      fecha_creacion_inicial: [null],
      fecha_creacion_final: [null],
      usuario_funcionario: [null]
    });

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(
      (control) => new FormControl(false)
    );
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onConsultarAnotaciones(page: number) {
    this.reportesAnotacionesService
      .getDataTable({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarAnotaciones(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarAnotaciones(1);
  }

  limpiar() {
    this.filtro.reset();
    this.createPagingTable();
    this.onCamaraSelect();
    this.onEstadoRNTSelect();
    this.onTipoRNTSelect();
    this.onChanges();
    this.onEstadoSolicitud();
    this.onTipoSolicitud();
    this.onAnotaciones();
  }

  titleTable() {
    this.headerTabla = [
      "Cámara de comercio",
      "Número RNT",
      "Estado RNT",
      "Tipo RNT",
      "Nombre o Razón social",
      "Nit",
      "Dígito verificación",
      "Número Matrícula",
      "Tipo solicitud",
      "Estado solicitud",
      "Fecha radicación",
      "Número radicación",
      "Fecha última actualización",
      "Tipo anotación",
      "Anotación",
      "Fecha creación",
      "Usuario de creación",
      "Causal de devolución"
    ];
  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
        }
      }
    });
  }

  onEstadoRNTSelect() {
    this.rntConsultaService.getEstadosRnt().subscribe((resultado) => {
      if (resultado.result) {
        this.estadoRnt = resultado.data;
      }
    });
  }

  onTipoRNTSelect() {
    this.tipoRntService.getTipoRnt().subscribe((resultado) => {
      if (resultado.result) {
        this.tipoRNT = resultado.data;
      }
    });
  }

  onTipoSolicitud() {
    this.establecimientoComercioService
      .getTipoSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.tipoSolicitudLista = resultado.data as Array<TipoSolicitudEntry>;
        }
      });
  }

  onEstadoSolicitud() {
    this.establecimientoComercioService
      .getEstadosSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoSolicitudLista = resultado.data as Array<EstadoSolicitudEntry>;
        }
      });
  }

  onAnotaciones() {
    this.anotacionService.getTiposAnotaciones().subscribe((resultado) => {
      if (resultado.result) {
        this.tipos_anotacion = resultado.data;
      }
    });
  }

  onOpenModalFuncionario() {
    const modalRef = this.modalService.open(ModalSeleccionFuncionarioComponent,
      { centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl' });
    modalRef.result.then(resultado => {
      this.filtro.get('usuario_funcionario').patchValue(resultado.usuario);
    }).catch(resultado => {
      this.filtro.get('usuario_funcionario').patchValue(null);
    });
  }

  onChanges() {
    this.exportarForm.get("selectAll").valueChanges.subscribe((bool) => {
      this.exportarForm
        .get("exportarList")
        .patchValue(Array(this.exportarList.length).fill(bool), {
          emitEvent: false,
        });
    });

    this.exportarForm.get("exportarList").valueChanges.subscribe((val) => {
      const allSelected = val.every((bool) => bool);
      if (this.exportarForm.get("selecAll").value !== allSelected) {
        this.exportarForm
          .get("selectAll")
          .patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + next : prev), 0);
      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  minFiltroCheck() {
    if (this.filtro.get("estado_rnt_id").valid) {
      return false;
    } else {
      return true;
    }
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked, index) => (checked ? this.exportarList[index].id : null))
      .filter((value) => value !== null);

    this.columnasEnvio = selectedPreferences.join();

    this.reportesAnotacionesService
      .generarExportarAnotaciones({
        ...this.filtro.value,
        columnas: this.columnasEnvio,
      })
      .subscribe((resultado) => {
        if (resultado.type === HttpEventType.Response) {
          if (resultado.ok) {
            this.saveAsExcelFile(resultado.body, `reporte_anotaciones.xlsx`);
          }
        }
      });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  onCheckDate(minDate: NgbDate) {
    this.fecha_inicio = {
      day: minDate.day,
      month: minDate.month,
      year: minDate.year,
    };
  }
}
